<template>
  <div>
    <!--   2023 10/19  左边树结构隐藏-->
    <div class="left_tree" v-show="showLeft">
      <a-spin :spinning="treeSpin" style="height: 100%">
        <div>
          <a-radio-group v-model="type" @change="handleChange">
            <a-radio-button value="dept">
              部门
            </a-radio-button>
            <a-radio-button value="customer">
              员工
            </a-radio-button>
          </a-radio-group>
          <a-button @click="closeAll" style="margin-top: 12px">清空</a-button>
        </div>
        <div class="tree-box" v-if="type === 'dept'">
          <a-tree
              v-model="checkedKeys"
              :show-icon="true"
              checkable
              :expanded-keys="expandedKeys"
              :auto-expand-parent="autoExpandParent"
              :selected-keys="selectedKeys"
              :tree-data="treeData"
              :selectable="false"
              :replaceFields="{children:'children', title:'deptName', key:'deptId'}"
              @expand="onExpand"
              @check="onSelect"
          >
            <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
            <a-icon type="cluster" slot="region" style="color:#52c41a"/>
          </a-tree>
        </div>
        <div class="tree-box" v-if="type === 'customer'">
          <Tree :list="treeData" :selectedUser="selectedUser" :userName="''" :detph="0"
                @change="checkedUser"></Tree>
        </div>
      </a-spin>
    </div>
<!--    <div style="overflow-y: hidden" class="right_table" :class="{showLeft:!showLeft}">-->
      <div  class="right_table"  :class="{showLeft:!showLeft}">

      <a-icon type="left-circle" style="display: none!important;" class="close" @click="showLeft = false" v-if="showLeft"/>
      <a-icon type="right-circle" style="display: none!important;" class="close" @click="showLeft = true" v-else/>
    <div class="report_query_box">

      <!--      <div class="item_box">-->
      <!--        <span>所属单位：</span>-->
      <!--        <a-tree-select-->
      <!--            v-model="search.deptId"-->
      <!--            allow-clear-->
      <!--            :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"-->
      <!--            :treeData="treeDeptData"-->
      <!--            :replaceFields="{children:'children', title:'text', key:'id', value: 'id' }"-->
      <!--            style="width: 150px;"-->
      <!--        >-->
      <!--        </a-tree-select>-->
      <!--      </div>-->

      <div class="item_box" v-if="searchDateRangeShow">
        <span>日期：</span>
        <a-range-picker
            @change="onChangeDate"
            :default-value="dateDefaultDate"
            :format="dateFormat"
            style="width: 350px;"
        />
      </div>

      <div class="item_box">
        <span>品系：</span>
        <a-select
            v-model="search.strainName"
            :options="strainOptions"
            style="width: 150px;"
        >
        </a-select>
      </div>

      <div class="item_box">
        <span>经理部：</span>
        <a-select
            v-model="search.regionId"
            :options="regionOptions"
            style="width: 150px;"
            @change="changeRegionId"
        >
        </a-select>
      </div>

      <div class="item_box">
        <span>经销商：</span>
        <a-select
            show-search
            v-model="search.dealerName"
            :options="dealerOptions"
            style="width: 150px;"
        >
        </a-select>
      </div>

<!--      <div class="item_box">-->
<!--        <span>销售顾问：</span>-->
<!--        <a-input v-model="search.followUserName" style="width: 150px;" @keyup.enter.native="searchData"/>-->
<!--      </div>-->

      <div class="item_box">
        <span>客户姓名：</span>
        <a-input v-model="search.custName" style="width: 150px;" @keyup.enter.native="searchData"/>
      </div>

      <div class="item_box">
        <span>联系电话：</span>
        <a-input v-model="search.mobile" style="width: 150px;" @keyup.enter.native="searchData"/>
      </div>
      <div class="item_box">
        <span>流失原因：</span>
        <a-input v-model="search.failureReason" style="width: 150px;" @keyup.enter.native="searchData"/>
      </div>
      <div class="report_query_btns">
        <a-button class="func_btn_item" type="primary" @click="searchData">筛选</a-button>
        <a-button class="func_btn_item" @click="resetData">重置</a-button>
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="exportData('current')">
              <a-icon type="export"/>
              导出当前
            </a-menu-item>
            <a-menu-item key="2" @click="exportData('all')">
              <a-icon type="export"/>
              导出全部
            </a-menu-item>
          </a-menu>
          <a-button class="func_btn_item" type="primary"> 导出
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
      </div>
    </div>


    <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        bordered
        :loading="loading"
        size="middle"
        :scroll="{ x: 'calc(700px + 50%)', y: 600 }"
    />
  </div>
  </div>
</template>
<script>
import {formatter as fmt} from "@/utils/ebase-formatter";
import {dataApi} from "@/services/report/report.js";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";
import XEUtils from "xe-utils";
import moment from 'moment';
//新增的
import Tree from "@/components/picker/Tree";
//新增的
console.log(fmt, loadBaseCodeData)

// 多表头 固定表头
const columns = [
  {
    title: '品系',
    field: "strainName",
    dataIndex: 'strainName',
    key: 'strainName',
    width: 80,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '经理部',
    field: "regionName",

    dataIndex: 'regionName',
    key: 'regionName',
    width: 80,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '经销商',
    field: 'dealerName',
    dataIndex: 'dealerName',
    key: 'dealerName',
    width: 80,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '销售顾问',
    field: 'followUserName',

    dataIndex: 'followUserName',
    key: 'followUserName',
    width: 80,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '客户姓名',
    field: 'custName',

    dataIndex: 'custName',
    key: 'custName',
    width: 80,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '联系电话',
    field: 'mobile',

    dataIndex: 'mobile',
    key: 'mobile',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '意向购车数量',
    field: 'wantCount',

    dataIndex: 'wantCount',
    key: 'wantCount',
    width: 80,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '流失时间',
    field: 'createDate',

    dataIndex: 'createDate',
    key: 'createDate',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '流失品牌',
    field: 'brandName',

    dataIndex: 'brandName',
    key: 'brandName',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '流失车型',
    field: 'lostModel',

    dataIndex: 'lostModel',
    key: 'lostModel',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '原因分类',
    field: 'failureReason',

    dataIndex: 'failureReason',
    key: 'failureReason',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '战败原因',
    field: 'childFailureReason',

    dataIndex: 'childFailureReason',
    key: 'childFailureReason',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '具体流失原因',
    field: 'failureDesc',

    dataIndex: 'failureDesc',
    key: 'failureDesc',
    width: 100,
    align: 'center',
    className:'bg-color',
  },

];

export default {
  components: {
    //新增的
    Tree
    //新增的结束
  },
  data() {
    return {
      searchDateRangeShow: true,
      dateDefaultDate: [],
      dateFormat: 'YYYY-MM-DD',
      loading: false,
      tableData: [],
      columns,
      // treeDeptData: [],
      regionOptions: [],//经理部
      dealerOptions: [],//经销商
      strainOptions: [],//品系
      userOptions: [],//销售顾问
      //  新增的
      regionId: '', dealerId: '', userId: '', deptId: '',
      //角色树
      autoExpandParent: false,
      defaultExpandedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      deptList: [],
      treeData: [],
      selectedUser: [],
      treeSpin: false,
      showLeft: false,
      type: 'dept',
      //  新增的结束

      search: {
        page: 1,
        limit: 10,
        startTime: '',
        endTime: '',
        // dealerId: '',// 经销商id
        regionId: '',// 经理部id
        dealerName: '',// 经销商名字
        strainName: '',// 品系
        followUserNameId: '',// 销售顾问id
        followUserName: '',//销售顾问名称搜索
        custNameId: '',//客户姓名id
        custName: '',//客户姓名
        mobileId: '',//联系电话id
        mobile: '',//联系电话
        failureReason:'',//流失原因分析
        failureReasonId:''//流失原因分析Id

      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (page, pageSize) => { //切换页page
          console.log(page);
          console.log(pageSize);
          this.getTableData(page, pageSize);
        },
        showSizeChanger: true,
        onShowSizeChange: (current, size) => { //切换pageSize
          console.log('当前页码', current)
          console.log(size)
          this.getTableData(1, size);
        },
      }
    };
  },
  created() {
    this.handleDefaultDateRange();
  },
  async mounted() {
    this.loadSearchBaseData();
    this.getTableData();
    //新增的开始
    this.init()//一开始就显示树
    //新增的结束
  },
  methods: {
    moment,
    handleDefaultDateRange() {
      //日期默认月初 - 到当天
      this.dateDefaultDate = [];
      this.search.startTime = XEUtils.toDateString(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd')
      this.search.endTime = XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
      this.dateDefaultDate.push(moment(this.search.startTime))
      this.dateDefaultDate.push(moment(this.search.endTime))
    },
    /**
     * 获取多表头表格数据
     * @param currentPage 当前页码 默认1
     * @param pageSize pageSize 默认10
     */
    getTableData(currentPage, pageSize) {
      this.search.page = currentPage ? currentPage : 1;
      this.search.limit = pageSize ? pageSize : 10;

      console.log('page变化', this.search.page)
      this.loading = true;
      dataApi.clueFailReportData({...this.search}).then(res => {
        console.log('tableData', res)
        this.loading = false;

        let resData = res.data;
        if (!resData.list.length) {
          console.log('暂无数据');
          this.tableData = [];
          this.pagination.total = 0;
          return false;
        }

        if (currentPage) {
          this.pagination.current = currentPage;
        }
        this.pagination.total = resData.totalCount;
        this.pagination.pageSize = resData.pageSize;

        this.tableData = [];
        resData.list.forEach((item, index) => {
          this.tableData.push({
            key: index,
            "strainName": item.strainName,  //   品系
            "regionName": item.regionName, //   经理部
            "dealerName": item.dealerName, //    经销商
            "followUserName": item.followUserName,  //   销售顾问
            "custName": item.custName, //    客户姓名
            "mobile": item.mobile,  //    联系电话
            "wantCount": item.wantCount,  //    意向购车数量
            "createDate": item.createDate,   //      流失时间
            "brandName": item.brandName, //    流失品牌
            "lostModel": item.lostModel,   //   流失车型
            "failureReason": item.failureReason,  //    原因分类
            "childFailureReason": item.childFailureReason,  //    战败原因
            "failureDesc": item.failureDesc,   //   具体流失原因
            "dealerId": item.dealerId,  //   经销商id
            "deptId": item.deptId, //   销售顾问部门id
            "followUserNameId": item.followUserNameId,  //   销售顾问
            "custNameId": item.custNameId,  //   客户姓名
            "mobileId": item.mobileId,  //   联系电话
            "regionId": item.regionId, //   经理部id
            "strainId": item.strainId, //   品系id
          })
        })
      });
    },
    //重置
    resetData() {
      this.handleDefaultDateRange();
      //处理更新日期组件不更新问题
      this.searchDateRangeShow = false;
      this.$nextTick(() => {
        this.searchDateRangeShow = true;
      })
      this.search.dealerName = '';
      // this.search.dealerId = '';
      this.search.deptId = '';
      this.search.regionId = '';
      this.search.strainName = '';
      this.search.followUserName = '';
      this.search.custName = '';
      this.search.mobile = '';
      this.search.failureReason = '',
//新增的
      this.search.userId='';
      // 新增的
      this.search = {
        ...this.search,
        'filter.eq.dealerName': '',
        // 'filter.eq.dealerId': '',
        'filter.eq.deptId': '',
        'filter.eq.regionId': '',
        'filter.eq.strainName': '',
        'filter.like.followUserName': '',
        'filter.like.custName': '',
        'filter.like.mobile': '',
        'filter.like.failureReason': '',

      }
      //新增的
      this.selectedUser = []
      this.checkedKeys = []
      //新增的
      this.getTableData()
    },
    // 搜索
    async searchData() {
      this.search = {
        ...this.search,
        'filter.eq.dealerName': this.search.dealerName,
        // 'filter.eq.dealerId': this.search.dealerId,
        'filter.eq.deptId': this.search.deptId,
        'filter.eq.regionId': this.search.regionId,
        'filter.like.followUserName': this.search.followUserName,
        'filter.eq.strainName': this.search.strainName,
        'filter.like.custName': this.search.custName,
        'filter.like.mobile': this.search.mobile,
        'filter.like.failureReason': this.search.failureReason,

      }
      this.getTableData()
    },
    //todo 导出(暂时隐藏
    async exportData(type) {
      if (!this.tableData || this.tableData.length <= 0) {
        this.$message.error('当前没有数据可导出')
        return false
      }


      const params = {
        // ...this.search,
        mode: type,
        paper: {
          page: this.search.page,
          limit: this.search.limit
        },
        filename: "战败原因分析",
        containHeader: true,
        fields: [{title: "序号"},
          {field: "strainName", title: "品系"},
          {field: "regionName", title: "经理部"},
          {field: "dealerName", title: "经销商"},
          {field: "followUserName", title: "销售顾问"},
          {field: "custName", title: "客户姓名"},
          {field: "mobile", title: "联系电话"},
          {field: "wantCount", title: "意向购车数量"},
          {field: "createDate", title: "流失时间"},
          {field: "brandName", title: "流失品牌"},
          {field: "lostModel", title: "流失车型"},
          {field: "failureReason", title: "原因分类"},
          {field: "childFailureReason", title: "战败原因"},
          {field: "failureDesc", title: "具体流失原因"},
        ],
        original: false,
        sheetName: "后台管理端 | 战败原因分析"

      }
      this.loading = true;
      await dataApi.exportFile(api.report.REPORT + "/exportZhanBaiExcel?page="
          + this.search.page
          + '&limit=' + this.search.limit
          + '&startTime=' + this.search.startTime
          + '&endTime=' + this.search.endTime
          //新增的
          + '&dealerId=' + (type === 'current' ? this.dealerId : '')//this.dealerId
          + '&deptId=' + (type === 'current' ? this.deptId : '')//this.deptId
          + '&regionId=' + (type === 'current' ? this.regionId : '')//this.regionId
          + '&userId='  + (type === 'current' ? this.userId : '')//this.userId
          //新增的
          // + '&filter.eq.dealerId=' + (type === 'current' ? this.search.dealerId : '')
          // + '&filter.eq.regionId=' + (type === 'current' ? this.search.regionId : '')
          + '&filter.eq.strainName=' + ((this.search.strainName)&&(type === 'current' )? this.search.strainName : '')
          // + '&filter.like.followUserName=' + (type === 'current' ? this.search.followUserName : '')
          + '&filter.like.custName=' + ((this.search.custName)&&(type === 'current' )? this.search.custName : '')
          + '&filter.like.mobile=' + ((this.search.mobile)&&(type === 'current')? this.search.mobile : '')
          + '&filter.like.failureReason=' + ((this.search.failureReason)&&(type === 'current')? this.search.failureReason : '')
          , params).then(blob => {
        this.loading = false;
        // await dataApi.exportFile(api.report.REPORT + "/custReportExport" , params).then(blob => {
        this.$message.success('导出成功，开始下载');
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob.data); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '战败原因分析' + '.xls'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(e => {
        console.error('导出失败:' + e);
        this.$message.error('导出失败');
      })
    },
    // 选择日期区间
    onChangeDate(data, dataString) {
      this.search.startTime = dataString[0]
      this.search.endTime = dataString[1]
    },
    // 加载搜索下拉 树等数据
    async loadSearchBaseData() {
      //经理部
      let region = {
        isRegion: 1,
        isDealer: 0
      }
      this.regionOptions = await dataApi.selection(region);//经理部
      // 经理部下拉处理
      this.regionOptions = this.regionOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptId
        }
      })
      this.regionOptions = [{
        value: '',
        label: '全部'
      }].concat(this.regionOptions);

      //经销商
      let dealer = {
        isRegion: 0,
        isDealer: 1
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);

      //品系
      this.strainOptions = await dataApi.selectionStrain();//品系
      console.log(this.strainOptions)
      // this.strainOptions = await loadBaseCodeData('CD200007')
      this.strainOptions = this.strainOptions.data.map(v => {
        return {
          label: v.strainName,
          value: v.strainName
        }
      })
      this.strainOptions = [{
        value: '',
        label: '全部'
      }].concat(this.strainOptions);

      //销售顾问
      this.userOptions = await loadBaseCodeData('CD200002')
      this.userOptions = this.userOptions.map(v => {
        return {
          label: v.label,
          value: v.label
        }
      })
      this.userOptions = [{
        value: '',
        label: '全部'
      }].concat(this.userOptions);
      //
      // //客户姓名
      // this.custNameOptions = await loadBaseCodeData('CD200002')
      // this.custNameOptions = this.custNameOptions.map(v => {
      //   return {
      //     label: v.label,
      //     value: v.label
      //   }
      // })
      // this.custNameOptions = [{
      //   value: '',
      //   label: '全部'
      // }].concat(this.userOptions);
      //
      // //销售顾问
      // this.userOptions = await loadBaseCodeData('CD200002')
      // this.userOptions = this.userOptions.map(v => {
      //   return {
      //     label: v.label,
      //     value: v.label
      //   }
      // })
      // this.userOptions = [{
      //   value: '',
      //   label: '全部'
      // }].concat(this.userOptions);

    },

    //  新增的
    init() {//显示树
      dataApi.popSelect().then(res => {
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
      })
    },

    handleChange() {//框如果改变
      this.closeAll()
      this.init()
    },
    closeAll() {//清空已选择的radio选项
      // this.checkedKeys = []
      // this.followUserId = ''
      // this.regionId = ''
      // this.dealerId = ''
      // this.deptId = ''
      // this.search = ''
      //
      // XEUtils.mapTree(this.treeData, item => {
      //   if (item.userList) {
      //     item.userList.map(user => {
      //       user.checked = false
      //     })
      //   }
      //   return item
      // })
      // this.selectedUser = []
      // this.$nextTick(() => {
      // this.refresh()
      this.checkedKeys = []
      this.userId = ''
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      this.selectedUser = []
      // this.search = ''
      this.resetData()
      // })
    },
    //展开列表
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    //筛选开始
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []//做三个数组
      checkedNodes.forEach(item => {
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
          console.log('这是经销商')
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
          console.log('这是经理部')
        } else {
          deptId.push(item.key)
          console.log('这是dept')
        }
      })
      this.regionId = regionId.toString()
      this.dealerId = dealerId.toString()
      this.deptId = deptId.toString()
      // this.searchData()
      // {
      this.search = {
        dealerId: this.dealerId,
        regionId: this.regionId,
        deptId: this.deptId,
        startTime: this.search.startTime,
        endTime:this.search.endTime,
        // 'filter.eq.dealerId': this.dealerId,
        // 'filter.eq.deptId': this.deptId,
        // 'filter.like.userName': this.userName,
        // 'filter.eq.regionId': this.regionId,
        'filter.eq.strainName': (this.search.strainName)? this.search.strainName : '',
        'filter.eq.custName': (this.search.custName)? this.search.custName : '',
        'filter.eq.mobile': (this.search.mobile)? this.search.mobile : '',
        'filter.eq.failureReason': (this.search.failureReason)? this.search.failureReason : '',


      }
      this.$nextTick(() => {
        this.getTableData();
        console.log('筛出来了')
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
        console.log('销售顾问1')
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
        console.log('销售顾问2')
      }
      this.userId = this.selectedUser.map(item => {
        console.log('销售顾问3')
        return item.userId
      }).toString()
      this.search = {
        userId:this.userId,
        // 'filter.eq.deptId': this.deptId,
        // 'filter.eq.userId': this.followUserId,
        // 'filter.eq.regionId': this.regionId,
        startTime: this.search.startTime,
        endTime:this.search.endTime,
        'filter.eq.strainName': (this.search.strainName)? this.search.strainName : '',
        'filter.eq.custName': (this.search.custName)? this.search.custName : '',
        'filter.eq.mobile': (this.search.mobile)? this.search.mobile : '',
        'filter.eq.failureReason': (this.search.failureReason)? this.search.failureReason : '',


      }
      this.$nextTick(() => {
        this.getTableData();
        console.log('筛出来了')
      })
    },
    //  新增的结束
    // 2023 10/19监听筛选经理部 联动经销商
    changeRegionId(val){
      this.search.dealerName =''
      this.getDealerData(val)
    },
    /**
     * 2023 10/19经理部 经销商联动数据
     * @param id
     * @return {Promise<void>}
     */
    async getDealerData(id) {
      let dealer = {
        isRegion: 0,
        isDealer: 1,
        'filter.eq.parentId': id,
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);
    },
  }
};
</script>

<style scoped lang="less">
.report_query_box {
  padding: 30px 12px;
  display: flex;
  flex-wrap: wrap;

  .item_box {
    margin-right: 20px;
    margin-bottom: 12px;
  }

  .func_btn_item {
    margin-left: 12px;
    align-self: flex-end;
  }
}
//新增的开始
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}

//新增的结束
</style>
